import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit"
import { api } from "../../environments/environment";
import { LoaderService, Message } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styles: [],
  standalone: false,
})
export class ChangePasswordComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message
  ) {}

  email: string = "";
  showPassword = false;
  password = "";
  confirmPassword = "";
  token = "";
  app = "";
  acceptTerms = false;

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const token = params.get("token");
    const app = params.get("app");
    if (token && app) {
      this.app = app;
      this.token = token;
    } else {
      this.message.showMessage("Link reset password invalido", "error");
      this.backToLogin();
    }
  }

  checkboxTerms(event: any) {
    this.acceptTerms = event.checked;
  }

  backToLogin() {
    this.router.navigate(["/login"]);
  }
  changePassword() {
    if (this.password == this.confirmPassword) {
      this.loader.on();
      this.rest
        .post("/auth/recovery-password/" + this.token, {
          password: this.password,
        })
        .subscribe({
          next: () => {
            this.loader.off(true);
            this.message.showMessage(
              this.app == "0"
                ? "Password cambiata con successo"
                : "Password cambiata con successo ora puoi tornare all'app",
              "success",
              "message-fix-index"
            );
            if (this.app == "0") {
              this.backToLogin();
            }
          },
          error: (error) => {
            this.loader.off(true);
            this.message.showMessage(
              error.error.message,
              "error",
              "message-fix-index"
            );
          },
        });
    } else {
      this.message.showMessage(
        "Password e conferma password devono essere uguali",
        "error",
        "message-fix-index"
      );
    }
  }
}
